import React from "react";
import "./SampleCustomerComponent.scss";

function SampleCustomerComponent() {
  return <div className="sample">Sample Box</div>;
}

export default SampleCustomerComponent;
